import SelectSortOrder from './SelectSortOrder';
import { useSelector, useDispatch } from "react-redux";
import {selectMetadata, setSortSettings} from "../redux/reportSlice";
import { useEffect } from "react";

export default function SortPanel() {
    const dispatch = useDispatch();
    const metadata = useSelector(selectMetadata);
    const sortOrder = metadata && metadata.sortOrder ? metadata.sortOrder : null;
    const items = sortOrder ? sortOrder.options.map(itm => {return {id: itm.value, content: itm.label, index: itm.index};}) : [];
    const label = sortOrder ? sortOrder.label : '';
    const name = sortOrder ? sortOrder.name : '';
    
    useEffect(() => {
      onChange({selected: [], unselected: items});
    }, [items]);

    const onChange = (e) => {
      var sortOrderItems = (e.selected || []).concat(e.unselected).map((item) => item.id);
      dispatch(setSortSettings(sortOrderItems));
    };

    if(items.length > 0) {
      return (<SelectSortOrder label={label} list={items} name={name} onChange={onChange}/>);
    }
    else{
      return null;
    }
}
